<template>
  <el-row class="container">
    <el-col :span="24" class="header">
      <el-col :span="12">
        <div class="logo logo-width">

        </div>
        <span class="sysname-inner">{{ sysName }}</span>
      </el-col>

      <el-col :span="12" class="right">
        <el-dropdown trigger="hover" class="userinfo">
                    <span class="el-dropdown-link userinfo-inner"><img :src="userAvatar"/> {{
                        userInfo.username
                      }}</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-col>
    <el-col :span="24" class="main">
      <aside class="aside">
        <!--导航菜单-->
        <el-menu default-active="1" class="el-menu-vertical-demo">
          <el-menu-item index="1" @click="$router.push('homepage')" :disabled=disable>
            <i class="icon icon1"></i>
            <span slot="title">首页</span>
          </el-menu-item>

          <el-menu-item index="2" @click="$router.push('integralItem')" :disabled=disable>
            <i class="icon icon9"></i>
            <span slot="title">积分历史</span>
          </el-menu-item>

          <el-menu-item index="3" @click="$router.push('user')" :disabled=disable v-if="role==='superAdministrator'">
            <i class="icon icon9"></i>
            <span slot="title">账号管理</span>
          </el-menu-item>

          <el-menu-item index="4" @click="$router.push('propaganda')" :disabled=disable>
            <i class="icon icon9"></i>
            <span slot="title">合作伙伴管理</span>
          </el-menu-item>

        </el-menu>
      </aside>
      <section class="content-container">
        <router-view></router-view>
      </section>
    </el-col>
  </el-row>
</template>

<script>
import Cookies from 'js-cookie';

export default {
  name: 'navBar',
  data() {
    return {
      sysName: '',
      userAvatar: '',
      logo: '',
      userInfo: {},
      disable: false,
      role: '',
      hideDot: false
    }
  },
  methods: {
    logout: function () {
      this.$confirm('确认退出吗?', '提示', {
        type: 'warning'
      })
          .then(() => {
            Cookies.remove('userInfo');
            this.$router.push('/login');
          })
          .catch(() => {
          });
    },
  },
  mounted() {
    this.sysName = '易购';
    this.userAvatar = require('@/assets/images/top-icon4.png');

    this.userInfo = JSON.parse(Cookies.get('userInfo'));
    this.role = this.userInfo.role;
  }
};
</script>

<style scoped lang="scss">
.container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;

  .header {
    .item {
      margin-right: 40px;
    }

    height: 60px;
    line-height: 60px;
    background: #C2092A;
    color: #fff;

    .sysname-inner {
      padding-left: 30px;
      font-size: 20px;
    }

    .right {
      text-align: right;
    }

    .userinfo {

      .userinfo-inner {
        font-size: 16px;
        cursor: pointer;
        color: #fff;
        margin-left: 20px;

        img {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          margin: 10px 0 10px 10px;
          float: right;
        }
      }
    }

    .logo {

      img {
        width: auto;
        height: 40px;
        border-radius: 0;
        margin: 10px 10px 10px 10px;
        float: left;
      }
    }

    .logo-width {
      width: 230px;
    }
  }

  .main {
    display: flex;
    position: absolute;
    top: 60px;
    bottom: 0;
    overflow: hidden;

    aside {
      flex: 0 0 230px;
      width: 230px;

      .el-menu {
        height: 100%;
        overflow-y: auto;
        text-align: left;
      }
    }

    .content-container {
      flex: 1;
      padding: 0;
      background-color: #F0F0F0;
      padding: 15px 15px 0;
      overflow-y: auto;
    }
  }

  .icon {
    width: 16px;
    height: 16px;
    margin-right: 10px;
    display: inline-block;
    background: url("../assets/images/menu/icon1.png") no-repeat;
    background-size: contain;
  }

  .is-active .icon1 {
    background: url("../assets/images/menu/icon1-a.png") no-repeat;
    background-size: contain;
  }

  .icon2 {
    background: url("../assets/images/menu/icon-g.png") no-repeat;
    background-size: contain;
  }

  .is-active .icon2 {
    background: url("../assets/images/menu/icon-g-a.png") no-repeat;
    background-size: contain;
  }

  .icon3 {
    background: url("../assets/images/menu/icon3.png") no-repeat;
    background-size: contain;
  }

  .is-active .icon3 {
    background: url("../assets/images/menu/icon3-a.png") no-repeat;
    background-size: contain;
  }

  .icon4 {
    background: url("../assets/images/menu/icon-4.png") no-repeat;
    background-size: contain;
  }

  .is-active .icon4 {
    background: url("../assets/images/menu/icon-4-a.png") no-repeat;
    background-size: contain;
  }

  .icon5 {
    width: 14px;
    height: 14px;
    background: url("../assets/images/menu/icon5.png") no-repeat;
    background-size: contain;
  }

  .is-active .icon5 {
    background: url("../assets/images/menu/icon5-a.png") no-repeat;
    background-size: contain;
  }

  .icon6 {
    background: url("../assets/images/menu/icon-6.png") no-repeat;
    background-size: contain;
  }

  .is-active .icon6 {
    background: url("../assets/images/menu/icon-6-a.png") no-repeat;
    background-size: contain;
  }

  .icon7 {
    background: url("../assets/images/menu/icon-7.png") no-repeat;
    background-size: contain;
  }

  .is-active .icon7 {
    background: url("../assets/images/menu/icon-7-a.png") no-repeat;
    background-size: contain;
  }

  .icon8 {
    background: url("../assets/images/menu/icon-8.png") no-repeat;
    background-size: contain;
  }

  .is-active .icon8 {
    background: url("../assets/images/menu/icon-8-a.png") no-repeat;
    background-size: contain;
  }

  .icon9 {
    background: url("../assets/images/menu/icon-9.png") no-repeat;
    background-size: contain;
  }

  .is-active .icon9 {
    background: url("../assets/images/menu/icon-9-a.png") no-repeat;
    background-size: contain;
  }
}
</style>
